<template>
  <div v-if="findMissing.length > 0">
     <b-alert variant="danger" show>
         
            <h4 class="alert-heading">Missing Orders</h4>
            <p>
               <strong>Attention!</strong> Orders nos. <span v-for="(orderNo) in findMissing" :key="orderNo">{{ orderNo }}, </span> {{ findMissing.length == 1 ? 'is' : 'are' }} missing from range of orders {{ this.orderNos[this.orderNos.length - 1] }} <---> {{ this.orderNos[0] }} 
            </p>
            <hr>
            <p class="mb-0">
               Please do the needful.
            </p>
         
     </b-alert>
  </div>
</template>

<script>
  export default {
     props: {
       orderNos: {
          type: Array,
          default: () => ([])
       }
     },
     computed:{
        findMissing(){
           let start = this.orderNos[this.orderNos.length - 1];
           let end = this.orderNos[0]
           let missing = []
           for(let i= start; i <= end; i++){
              if(!this.orderNos.includes(i)){
                 missing.push(i)
              }
           }

           return missing;
        }
     }
  }
</script>

<style lang="scss" scoped>
   
</style>